import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';
import { Wolf404Gradient } from '../../../svgs/wolf-404-gradient';
import { ErrorBase, type ErrorBaseProps } from '../error-base';

export interface Error404Props
  extends Pick<
    ErrorBaseProps,
    'actionButton' | 'actionLink' | 'errorMessages'
  > {
  body?: ErrorBaseProps['body'];
}

export const Error404 = ({
  actionButton,
  actionLink,
  body,
  errorMessages,
}: Error404Props) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'errors.error404' });

  return (
    <ErrorBase
      title={t('title')}
      body={body ?? [t('body')]}
      icon={<Wolf404Gradient />}
      actionButton={actionButton}
      actionLink={actionLink}
      errorMessages={errorMessages}
    />
  );
};
